import { AepsType } from './aeps.type';


//aeps details


export const setMoneyTransferTotalAmount3 = (data) => ({
    type: AepsType.setMoneyTransferTotalAmount3,
    payload: data

});
export const setMoneyTransferSurChargeAmount3 = (data) => ({
    type: AepsType.setMoneyTransferSurChargeAmount3,
    payload: data

});
export const showCreateOrderResponse3 = (data) => ({
    type: AepsType.showCreateOrderResponse3,
    payload: data

});
export const setOrderId3 = (data) => ({
    type: AepsType.setOrderId3,
    payload: data

});
export const setAmount3 = (data) => ({
    type: AepsType.setAmount3,
    payload: data

});

export const setAepsOperator = (data) => ({
    type: AepsType.setAepsOperator,
    payload: data

});
export const setAepsMobile = (data) => ({
    type: AepsType.setAepsMobile,
    payload: data

});
export const setAepsOptional = (data) => ({
    type: AepsType.setAepsOptional,
    payload: data

});

export const selectedRechargableAmnt3 = (data) => ({
    type: AepsType.selectedRechargableAmnt3,
    payload: data

});


export const setTxnAmount3 = (data) => ({
    type: AepsType.setTxnAmount3,
    payload: data

});

export const setTxnsurcharge3 = (data) => ({
    type: AepsType.setTxnsurcharge3,
    payload: data

});

export const setTxntotalAmount3 = (data) => ({
    type: AepsType.setTxntotalAmoun3,
    payload: data

});


export const setMoneyTransferProgress3 = (data) => ({
    type: AepsType.setMoneyTransferProgress3,
    payload: data

});

export const setCreteOrderReq3 = (data) => ({
    type: AepsType.setCreteOrderReq3,
    payload: data

});

export const setCreateOrderRes3 = (data) => ({
    type: AepsType.setCreateOrderRes3,
    payload: data

});
export const setStatusEnqResponse3 = (data) => ({
    type: AepsType.setStatusEnqResponse3,
    payload: data

});


export const setAepsTxnHistory = (data) => ({
    type: AepsType.setAepsTxnHistory,
    payload: data

});


//biometric data
export const setBiometricDta = (data) => ({
    type: AepsType.setBiometricDta,
    payload: data

});

export const setBiometricDtaCaptureStatus = (data) => ({
    type: AepsType.setBiometricDtaCaptureStatus,
    payload: data

});

//aeps pricing

export const setAepsAmount = (data) => ({
    type: AepsType.setAepsAmount,
    payload: data

});

//aeps default page
export const setAepsSection = (data) => ({
    type: AepsType.setAepsSection,
    payload: data

});
export const checkingDriverStatus = (data) => ({
    type: AepsType.checkingDriverStatus,
    payload: data

});
export const setCaptureUrl = (data) => ({
    type: AepsType.setCaptureUrl,
    payload: data

});

export const setDeviceInfoUrl = (data) => ({
    type: AepsType.setDeviceInfoUrl,
    payload: data

});


export const setAepsResponse = (data) => ({
    type: AepsType.setAepsResponse,
    payload: data

});



export const setAepsRequest = (data) => ({
    type: AepsType.setAepsRequest,
    payload: data

});

export const storeAepsReqBeforeBalanceEnuiry = (data) => ({
    type: AepsType.storeAepsReqBeforeBalanceEnuiry,
    payload: data

});


export const setSelectedBankName = (data) => ({
    type: AepsType.setSelectedBankName,
    payload: data

});

export const setFullName = (data) => ({
    type: AepsType.setFullName,
    payload: data

});

export const setAadhaar = (data) => ({
    type: AepsType.setAadhaar,
    payload: data

});

export const setMobile = (data) => ({
    type: AepsType.setMobile,
    payload: data

});
export const setCurrentTimeStamp = (data) => ({
    type: AepsType.setCurrentTimeStamp,
    payload: data

});

export const setFilterStartDate = (data) => ({
    type: AepsType.setFilterStartDate,
    payload: data

});
export const setFilterEndDate = (data) => ({
    type: AepsType.setFilterEndDate,
    payload: data

});
export const setReadyDeviceName = (data) => ({
    type: AepsType.setReadyDeviceName,
    payload: data

});

export const setAepsCashWithDrwalReq = (data) => ({
    type: AepsType.setAepsCashWithDrwalReq,
    payload: data

});

  
export const setMoneyTransferProgress = (data) => ({
  type: AepsType.setMoneyTransferProgress,
  payload: data
  
});

export const resetAeps = {
    type: AepsType.RESET
}

